module.exports = __webpack_public_path__ + "img/link-horizontal-slash.fb05e3a3.svg";